import React, { useState, useEffect } from "react";
import StepCircle from "../StepCircle";
import {
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Stepper,
  Step,
  StepLabel,
  Grid,
} from "@mui/material";
import api from "../../api";

const steps = ["Datos Básicos", "Detalles Técnicos", "Otros Detalles"];

const EditarVehiculo = ({ vehiculo, handleClose, onUpdate }) => {
  const [step, setStep] = useState(0);
  const [editedVehiculo, setEditedVehiculo] = useState({
    patente: "",
    tipo_vehiculo: "",
    marca: "",
    modelo: "",
    anio: "",
    chasis: "",
    motor: "",
    kilometraje: "",
    fecha_act_km: "",
    tipo_combustible: "nafta",
    estado: "OPERATIVO",
    fecha_ultimo_service: "",
    km_ultimo_service: "",
    km_proximo_service: "",
    alineacion_balanceo_km: "",
    tag: null,
    vencimiento_matafuego: "",
    medida_neumatico: "",
    indice_neumatico: "",
    medida_bateria: "",
    color: "",
    carpeta_en_drive: false,
    llave: "",
    direccion_sede: "",
    area_responsable: "",
    titular: "",
    observaciones_mecanicas: "",
    observaciones_carroceria: "",
  });

  // Load vehiculo data on mount or when vehiculo changes
  useEffect(() => {
    if (vehiculo) {
      console.log("vehiculo.carpeta_en_drive raw value:", vehiculo.carpeta_en_drive);

      setEditedVehiculo({
        ...vehiculo,
        tag: vehiculo.tag === null ? null : vehiculo.tag,
        carpeta_en_drive: !!vehiculo.carpeta_en_drive,
      });
    }
  }, [vehiculo]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      console.log(`${name} changed to`, checked); // Debug line
      setEditedVehiculo({ ...editedVehiculo, [name]: checked });
    } else if (name === "tag") {
      const intValue = parseInt(value, 10);
      setEditedVehiculo({
        ...editedVehiculo,
        [name]: value === "" || isNaN(intValue) ? null : intValue,
      });
    } else {
      setEditedVehiculo({ ...editedVehiculo, [name]: value });
    }
  };

  const handleNext = () => setStep((prev) => prev + 1);
  const handleBack = () => setStep((prev) => prev - 1);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Sending data:", editedVehiculo); // <--- Add this to see what goes to backend
    api
      .put(`vehiculos/${editedVehiculo.id}/`, editedVehiculo)
      .then((res) => {
        alert("Vehículo actualizado correctamente");
        if (onUpdate) {
          onUpdate(res.data); // send the new data to parent
        }
        handleClose();
      })
      .catch(() => alert("Hubo un error al actualizar el vehículo."));
  };


  if (!vehiculo) {
    return <div>Cargando vehículo...</div>;
  }

  const toTitleCase = (str) =>
    str.replace(/_/g, " ").replace(/\w\S*/g, (txt) =>
      txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );

  const fieldLabels = {
    anio: "Año",
    chasis: "Chasis",
    motor: "Motor",
    kilometraje: "Kilometraje",
    fecha_act_km: "Fecha Act Km",
    fecha_ultimo_service: "Fecha Último Service",
    km_ultimo_service: "Km Último Service",
    km_proximo_service: "Km Próximo Service",
    alineacion_balanceo_km: "Alineación Balanceo Km",
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{ width: "100%", maxWidth: "700px", margin: "0 auto" }}
    >
      <Typography variant="h6" style={{ color: "#152d51", fontWeight: "bold" }}>
        Editar Vehículo
      </Typography>
      <Stepper activeStep={step} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={StepCircle}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {step === 0 && (
        <Grid container spacing={2} mt={2}>
          {["patente", "tipo_vehiculo", "marca", "modelo"].map((field, idx) => (
            <Grid item xs={6} key={idx}>
              <TextField
                label={field.charAt(0).toUpperCase() + field.slice(1).replace("_", " ")}
                name={field}
                value={editedVehiculo[field] || ""}
                onChange={handleChange}
                fullWidth
                required
              />
            </Grid>
          ))}
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="contained"
              sx={{ background: "#152d51" }}
              onClick={handleNext}
              disabled={
                !(
                  editedVehiculo.patente &&
                  editedVehiculo.tipo_vehiculo &&
                  editedVehiculo.marca &&
                  editedVehiculo.modelo
                )
              }
            >
              Siguiente
            </Button>
          </Grid>
        </Grid>
      )}

      {step === 1 && (
        <Grid container spacing={2} mt={2}>
          {[
            ["anio", "number"],
            ["chasis", "text"],
            ["motor", "text"],
            ["kilometraje", "number"],
            ["fecha_act_km", "date"],
            ["fecha_ultimo_service", "date"],
            ["km_ultimo_service", "number"],
            ["km_proximo_service", "number"],
            ["alineacion_balanceo_km", "date"],
          ].map(([field, type = "text"], idx) => (
            <Grid item xs={6} key={idx}>
              <TextField
                label={fieldLabels[field] || toTitleCase(field)}
                name={field}
                type={type}
                value={editedVehiculo[field] || ""}
                onChange={handleChange}
                fullWidth
                {...(type === "date" && { InputLabelProps: { shrink: true } })}
              />
            </Grid>
          ))}
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel sx={{ background: "#fff" }}>Combustible</InputLabel>
              <Select
                name="tipo_combustible"
                value={editedVehiculo.tipo_combustible || "nafta"}
                onChange={handleChange}
              >
                {["nafta", "diesel", "electrico", "hibrido"].map((option) => (
                  <MenuItem value={option} key={option}>
                    {option.charAt(0).toUpperCase() + option.slice(1)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel sx={{ background: "#fff" }}>Estado</InputLabel>
              <Select
                name="estado"
                value={editedVehiculo.estado || "disponible"}
                onChange={handleChange}
              >
                {["NO OPERATIVO", "CEDIDO", "OPERATIVO"].map(
                  (option) => (
                    <MenuItem key={option} value={option}>
                      {option.replace("_", " ")}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl>
              <label style={{ display: "block", marginBottom: 6, fontWeight: 500 }}>
                Carpeta en Drive
              </label>
              <input
                type="checkbox"
                name="carpeta_en_drive"
                checked={!!editedVehiculo.carpeta_en_drive}
                onChange={handleChange}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <Button fullWidth variant="outlined" onClick={handleBack}>
              Atrás
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              variant="contained"
              sx={{ background: "#152d51" }}
              onClick={handleNext}
            >
              Siguiente
            </Button>
          </Grid>
        </Grid>
      )}

      {step === 2 && (
        <Grid container spacing={2} mt={2}>
          {[
            "tag",
            "vencimiento_matafuego",
            "medida_neumatico",
            "indice_neumatico",
            "medida_bateria",
            "color",
            "llave",
            "direccion_sede",
            "area_responsable",
            "titular",
          ].map((field, idx) => (
            <Grid item xs={6} key={idx}>
              {field === "vencimiento_matafuego" ? (
                <TextField
                  label={toTitleCase(field)}
                  name={field}
                  type="date"
                  value={editedVehiculo[field] || ""}
                  onChange={handleChange}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              ) : (
                <TextField
                  label={toTitleCase(field)}
                  name={field}
                  type={field === "tag" ? "number" : "text"}
                  value={editedVehiculo[field] || ""}
                  onChange={handleChange}
                  fullWidth
                />
              )}
            </Grid>
          ))}
          <Grid item xs={12}>
            <TextField
              label="Observaciones Mecánicas"
              name="observaciones_mecanicas"
              value={editedVehiculo.observaciones_mecanicas || ""}
              onChange={handleChange}
              fullWidth
              multiline
              rows={3}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Observaciones Carrocería"
              name="observaciones_carroceria"
              value={editedVehiculo.observaciones_carroceria || ""}
              onChange={handleChange}
              fullWidth
              multiline
              rows={3}
            />
          </Grid>
          <Grid item xs={6}>
            <Button fullWidth variant="outlined" onClick={handleBack}>
              Atrás
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ background: "#152d51" }}
            >
              Guardar Cambios
            </Button>
          </Grid>
        </Grid>
      )}
    </form>
  );
};

export default EditarVehiculo;
